import script from "./HTpvpTFGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTpvpTFGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTpvpTFGameSetting.vue?vue&type=style&index=0&id=9aba0c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aba0c38"]])

export default __exports__